import React from 'react';
import store from 'store';
import classnames from 'classnames';
import { Link } from 'react-router-dom';

import styles from './DesktopMenu.module.scss';

//utils
import { config } from '../../../../utils/config';

// Components
import Button from '../../Button';

const DesktopMenu = () => {
    const isPWA = store.get(config.user.isPWA);
    const isLoggedIn = store.get(config.user.authToken);

    return (
        <div className={styles.row}>
            <div className={styles.column}>
                <h4>Linkuri utile</h4>

                <ul>
                    <li>
                        <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={config.path.iqos.iqosContacteaza}
                        >
                            Contact
                        </a>
                    </li>
                    <li>
                        <a
                            href={'/scan/lista-castigatori'}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Listă câștigători
                        </a>
                    </li>
                </ul>
            </div>

            <div className={classnames(styles.column, styles.isWide)}>
                <h4>Legal</h4>

                <ul>
                    <li>
                        <Button href="http://www.anpc.gov.ro" target="_blank" type="text">
                            ANPC
                        </Button>
                    </li>

                    <li>
                        {isLoggedIn ? (
                            <div />
                        ) : (
                            <a
                                href={config.path.iqos.termsConditions}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Termeni și condiții
                            </a>
                        )}
                    </li>

                    <li>
                        <a
                            href={config.path.iqos.privacy}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Protectia datelor personale
                        </a>
                    </li>

                    <li>
                        <a
                            href={config.path.iqos.cookiesPolicy}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Politică de cookies
                        </a>
                    </li>

                    <li>
                        <button id="ot-sdk-btn" className="ot-sdk-show-settings">
                            Gestionează cookies
                        </button>
                    </li>
                    <li>
                        <a
                            href={config.path.regulament}
                            target="_blank"
                            download
                            rel="noopener noreferrer"
                            className={isPWA ? styles.colorBlack : styles.colorWhite}
                        >
                            Regulamentul campaniei
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default DesktopMenu;
